import React, {useEffect} from "react";
import './support.scss';
import {Link, navigate} from "gatsby";
import Button from "../../common/button/button";
import Gleap from "gleap";

function SupportComponent({title, coloredTitle, description}) {

  const openChat = () => {
    Gleap.startConversation(true);
    Gleap.setTicketAttribute('note', 'User requested an Enterprise plan');
  }

  useEffect(() => {
    Gleap.initialize("qTwmjufNmPXyIAesxuRnhSxBONPR8rEu");
  }, [])

  return (
    <div className="why-trafft__team">
        <div className="why-trafft__team__content">
          <h2>{title} <span className="blue-text">{coloredTitle}</span>  </h2>
          <p>{description}</p>
          <div className="why-trafft__team__content__buttons">
            <Link to='/demo' className="tag-tracking-capterra">
              <Button
                type="primary"
                label='Book a Demo'
              />
            </Link>
            <Button
              type="ghost"
              label='Need help?'
              onClick={openChat}
            />
          </div>
        </div>
    </div>
  )
}

export default SupportComponent